import { render, staticRenderFns } from "./monitorDetail.vue?vue&type=template&id=12324106&scoped=true"
import script from "./monitorDetail.vue?vue&type=script&lang=js"
export * from "./monitorDetail.vue?vue&type=script&lang=js"
import style0 from "./monitorDetail.vue?vue&type=style&index=0&id=12324106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12324106",
  null
  
)

export default component.exports